export default __webpack_public_path__ + "static/media/img11.d3e46c66.jpg";